import axios from "axios";
import { getLanguageCode } from "./language_helper";

/**
 * Tell the backend which language the user selected.
 *
 * Every file under src/apis builds its request with the default axios
 * instance, so a single global request interceptor covers all of them without
 * touching the API layer. Only headers are added - method, url, payload and
 * every existing header are left exactly as they were.
 */
let installed = false;

export const installLanguageInterceptor = () => {
  if (installed) return;
  installed = true;

  axios.interceptors.request.use((requestConfig) => {
    const language = getLanguageCode();

    requestConfig.headers = requestConfig.headers || {};

    // do not override a language header explicitly set by a caller
    if (!requestConfig.headers["Accept-Language"]) {
      requestConfig.headers["Accept-Language"] = language;
    }
    if (!requestConfig.headers["X-Locale"]) {
      requestConfig.headers["X-Locale"] = language;
    }

    return requestConfig;
  });
};

export default installLanguageInterceptor;
